// extracted by mini-css-extract-plugin
export default {"card":"SectionRight_card__XJ28o","flex":"SectionRight_flex__MzvY2","head1":"SectionRight_head1__vvk2Y","head2":"SectionRight_head2__UZquu","head3":"SectionRight_head3__kuzqi"};